import api from '../../api';
import { TBetsCsv, TDownloadBetsParams } from './downloadBets.types';

const downloadBetsURL = '/bookie/regulator/download-bets';

// Regulator - Bets History - Csv download

export const queryDownloadBets = (params: TDownloadBetsParams) =>
  api.get<TBetsCsv>(downloadBetsURL, { params }).then((res) => res.data);
